// extracted by mini-css-extract-plugin
export var container = "_tu-0";
export var table = "_tu-2";
export var tableWrapper = "_tu-1";